import constants from './constants';

const initState = {
  device_type_name: '',
  device_type_description: '',
  device_type_communication_interface: '',
  device_type_baud_rate: '',
  device_type_address: '',
  maps: [],
  variables: [],

  createEditValues: null,
  isEditDefault: null,
};

function modbusMapsReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SET_IS_EDIT_DEFAULT:
      return {
        ...state,
        isEditDefault: payload,
      };

    case constants.SET_CREATE_EDIT_VALUES:
    case constants.ADD_CREATE_EDIT_VALUES_GROUP_MAPS:
    case constants.REMOVE_CREATE_EDIT_VALUES_GROUP_MAPS:
    case constants.ADD_CREATE_EDIT_VALUES_GROUP_VARIABLES:
    case constants.REMOVE_CREATE_EDIT_VALUES_GROUP_VARIABLES:
      return {
        ...state,
        createEditValues: payload,
      };

    default:
      return state;

  }

}

export default modbusMapsReducer;
